import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { superAdminBillsApi } from "../../../api/superAdminBillsApi";
import { CircularIndeterminate } from "../../../components/common/CircularIndeterminate";
import { MainContentWrapper, TableWrapper } from "../../../components/common/Common.styles";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import { ServerSidePagination } from "../../../components/common/table/ServerSidePagination";
import ServerSideSearchBar from "../../../components/common/table/ServerSideSearchBar";
import { useServerSidePagination } from "../../../hooks/PaginationHooks";
import { useProcessingRequest } from "../../../store/selectors/tableManagementSelector";
import { AnalysisFileType } from "../../../types/analysisFileTypes";
import AnalysisFileTableHeader from "./AnalysisFileTableHeader";
import AnalysisFileTableRow from "./AnalysisFileTableRow";
import { SearchBarWrapper } from "../../../components/common/stylings/SearchBarWrapper.styles";

interface Props {
    fileType: AnalysisFileType;
    title: string;
    link: string;

}

export default function GenericAnalysisFilesAdminPage(props: Props) {
    const { t } = useTranslation();

    const breadcrumbs = [
        {
            title: "superAdminPage.title",
            link: "superadminarea",
        },
        {
            title: props.title,
            link: props.link,
        },
    ];

    const processingRequest = useProcessingRequest()
    const paginatedData = useServerSidePagination(
        async (paginationParameters) => {
            const res = await superAdminBillsApi.getSuperAdminAnalysisFilesByFileType(
                paginationParameters,
                props.fileType
            );
            return res?.getResultOrNull();
        },
        [],
        "desc",
        "creationTimestamp"
    )

    return (<>
        <PageTitle breadcrumbs={breadcrumbs} title={t(props.title)} />

        <MainContentWrapper>
            <SearchBarWrapper>
                <ServerSideSearchBar onSearchHandler={paginatedData.handleOnSearch} />
            </SearchBarWrapper>

            <TableWrapper
                minWidth="1000px"
                columnsTemplate="1.4fr 1fr 1fr 0.5fr"
            >
                <AnalysisFileTableHeader
                    paginatedData={paginatedData}
                    showCompanyName />

                <Box sx={{ display: "contents" }}>
                    {paginatedData.items.map((item) =>
                        <AnalysisFileTableRow
                            row={item}
                            showCompanyName
                        />)
                    }
                </Box>
            </TableWrapper>
            <ServerSidePagination paginatedData={paginatedData} />
        </MainContentWrapper>

        <CircularIndeterminate processingRequest={processingRequest} />
    </>);
}